import { useAuth0 } from "@auth0/auth0-react";
// import { useCookies } from "react-cookie";

import LoadingSpinner from "../../components/LoadingSpinner";
import { useEffect } from "react";
const removeCookie = (name: string) => {
  document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};
const Logout = () => {
  const { logout } = useAuth0();
  console.log("Logout");


  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const [_, __, removeCookie] = useCookies(["PLATEAUTH", "PLATEAUSER"]);
  useEffect(() => {
    console.log("Logout");

    removeCookie("PLATEAUTH");
    removeCookie("PLATEAUSER");
    console.log("Removed cookies");
    if (window.initAuthNavigation) {
      window.initAuthNavigation();
    }
    console.log("Signed out");

    logout({
      returnTo: window.location.origin,
    });
  }, [logout]);

  return <LoadingSpinner />;
};

export default Logout;
